import moduleCreateDraftCopy from "./moduleCreateDraftCopy";
import moduleTableTICAccepted from "./tableContrallor/moduleTableTICAccepted";
import moduleTableRejected from "./tableContrallor/moduleTableTICRejected";
import moduleTableTICWaitingList from "./tableContrallor/moduleTableTICWaitingList";
import moduleTableAttendedMedicHCM from "./tableMedicHCM/moduleTicAttended";
import moduleTableInProcessMedicHCM from "./tableMedicHCM/moduleTicInProcess";
import moduleTableWaitingListMedicHCM from "./tableMedicHCM/moduleTicWaitingList";
import moduleTableHistoryTICPatient from "./tablesMedicAps/moduleHistoryTICPatient";
import moduleTableTICCreated from "./tablesMedicAps/moduleTableTICCreated";
import moduleTableTicDraftCopy from "./tablesMedicAps/moduleTableTicDraftCopy";
import moduleTableTICSent from "./tablesMedicAps/moduleTableTICSent";
import moduleTableTICAttended from "./tablesSomeHCM/moduleTicAttended";
import moduleTableTICReception from "./tablesSomeHCM/moduleTicReception";
import moduleTableTICWaitingListSomeHCM from "./tablesSomeHCM/moduleTicWaitingList";
const exportModuleTeleOpi = {
    namespaced: true,
    modules: {
        tableHistoryTICPatient: moduleTableHistoryTICPatient,
        tableTICCreated: moduleTableTICCreated,
        tableTICSent: moduleTableTICSent,
        tableWaitingListContrallorAPS: moduleTableTICWaitingList,
        tableAcceptedContrallorAPS: moduleTableTICAccepted,
        tableRejectedContrallerAPS: moduleTableRejected,
        tableWaitingListSomeHCM: moduleTableTICWaitingListSomeHCM,
        tableReceptionSomeHCM: moduleTableTICReception,
        tableAttendedSomeHCM: moduleTableTICAttended,
        tableWaitingListMedicHCM: moduleTableWaitingListMedicHCM,
        tableInProcessMedicHCM: moduleTableInProcessMedicHCM,
        tableAttendedMedicHCM: moduleTableAttendedMedicHCM,
        tableTicDraftCopy: moduleTableTicDraftCopy,
        createDraftCopy: moduleCreateDraftCopy,
    },
};
export default exportModuleTeleOpi;
